import { Component, OnInit } from '@angular/core';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { FyPayRates } from '../../hrCommon';
import { CacheItem, TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component';

@Component({
  selector: 'fy-pay-rates-table',
  templateUrl: './fy-pay-rates-table.component.html',
  styleUrls: ['./fy-pay-rates-table.component.css'],
  providers: [MainGridService]
})

export class FyPayRatesTableComponent implements OnInit {

  tablePermissions: AimsCommonTablePermissions = {
    create: false, // Set below in constructor
    update: false, // Set below in constructor
    delete: false,
  };
  initialTableElement;

  fyPayRates: Observable<any>;
  fyPayRatesHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'jobTitleId', label: 'Job Title - Work Section', type: 'dynamic', filterType: 'dynamic', events: { filterAndSortCompare: (term, el) => term === el.jobTitleId }, validatorOrOpts: [Validators.required] },
    { key: 'fiscalYear', label: 'Fiscal Year', type: 'number', validatorOrOpts: [Validators.required, Validators.minLength(4)] },
    { key: 'payRate', label: 'Pay Rate', type: 'dynamic', validatorOrOpts: [Validators.required] },
    { key: 'pmmApprovedById', label: 'PMM Approved By', type: 'dynamic', filterType: 'dynamic', width: 200, editable: false },
    { key: 'pmmApprovedOn', label: 'PMM Approved On', type: 'date', format: 'shortDate', editable: false },
    { key: 'hrmApprovedById', label: 'HRM Approved By', type: 'dynamic', filterType: 'dynamic', editable: false },
    { key: 'hrmApprovedOn', label: 'HRM Approved On', type: 'date', format: 'shortDate', editable: false },
    { key: 'pscsGenerated', label: 'PSC Generated?', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN, editable:false }
  ];

  newFyPayRates() {
    return new FyPayRates();
  }

  constructor(
    private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>
  ) {
    this.tablePermissions.create = permissions.canCreate(permissions.ComponentID.HumanResourcesConfig);
    if (permissions.canUpdate(permissions.ComponentID.HumanResourcesConfig)) {
      this.tablePermissions.update = (el) => !el.pscsGenerated;
    }
    this.fyPayRates = this.mainGridService.getAll('Hr/GetFyPayRates', 'Hr/SaveFyPayRates');
  }

  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  //Dropdowns
  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);
  jobTitlesUnionValues = this.transferHttp.getSingle('hr/GetJobTitlesUnionOnlyForDropDown');
  fyYearValues = this.transferHttp.getSingle('hr/GetDistinctFyYearsForDropDown');

  ngOnInit(): void {
    this.initialTableElement = this.newFyPayRates();
  }

  handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe());
  }

  handleRowAdd(update: TableRowUpdate): void {
    this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe());
  }

  public addFyRecords() {

    let fyYear: string;
    let currentYear = (new Date()).getFullYear();

    fyYear = prompt("Enter Fiscal Year: ");
    this.showSpinner = true;
    this.spinnerText = 'Adding Fiscal Pay records for ' + fyYear;

    let fyYearInt = parseInt(fyYear);

    if (fyYear == null || fyYear == "") {

    } else if (isNaN(fyYearInt) || fyYearInt <= currentYear || fyYearInt > 2099) {

      alert("You must enter a 4 digit year >= this year and <= 2099!");

    } else {
      this.transferHttp.post('hr/SaveNewFyPayRates?fyYear=', + fyYear).subscribe(retVal => {
        this.fyPayRates = this.transferHttp.getSingle('hr/GetFyPayRates');
        this.showSpinner = false;
      });
    }
  }

  ngOnDestroy() {
  }
}
